import http from "../../http-common";
import TokenService from "./TokenService";

class AuthService {
  //  register = (username, email, password) => {
  //   return api.post("/auth/signup", {
  //     username,
  //     email,
  //     password
  //   });
  // };

  login = (email, password) => {
    const data = http
      .post("/api/auth/signin", {
        email: email,
        password: password,
        domainId: 7,
      })
      .then((response) => {
        if (response.data.accessToken) {
          TokenService.setUser(response.data);
        }

        return response.data;
      });
    return data;
  };
  logout = () => {
    TokenService.removeUser();
  };

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  isEditor() {
    if (
      JSON.parse(localStorage.getItem("user").roles.includes("ROLE_EDITOR"))
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export default new AuthService();

// eslint-disable-next-line no-unused-vars
const parseJwt = (token) => {
  try {
    return JSON.parse(window.atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};
